import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/plugins/i18n/locales/en'
import mensajes from '@/plugins/i18n/locales/es'

Vue.use(VueI18n)

const language = localStorage.getItem('lang') || 'en'

export const i18n = new VueI18n({
  locale: language, // set locale
  fallbackLocale: language,
  messages: {
    en: messages,
    es: mensajes,
  }, // set locale messages
})

const loadedLanguages = [language] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  localStorage.setItem('lang', lang)

  return lang
}

export function getI18nLanguage() {
  return i18n.locale
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  /* eslint-disable prefer-template */
  return import(/* webpackChunkName: "lang-[request]" */ '@/plugins/i18n/locales/' + lang + '.js').then(msgs => {
    i18n.setLocaleMessage(lang, msgs.default)
    loadedLanguages.push(lang)

    return setI18nLanguage(lang)
  })
  /* eslint-enable */
}
